import * as React from 'react';

import { useListHomeEventsLazyQuery, ListHomeEventsQuery } from '@graphql';
import { Sliders, Highlight } from '@components';
import { EVENTS_SPOTS_CACHE_TTL, EVENTS_LAST_CALL } from '@utils';

export default function EventsPage() {
  const [events, setEvents] = React.useState<ListHomeEventsQuery['eventCategories'] | null>(null);

  const getLastCallFromStorage = () => {
    const storedLastCall = localStorage.getItem(EVENTS_LAST_CALL);
    return storedLastCall ? parseInt(storedLastCall, 10) : new Date().getTime();
  };
  const [lastCall, setLastCall] = React.useState<number>(getLastCallFromStorage());

  const [getEvents] = useListHomeEventsLazyQuery({
    onCompleted: ({ eventCategories }) => {
      setEvents(eventCategories ?? null);
      const now = new Date().getTime();
      setLastCall(now);
      localStorage.setItem(EVENTS_LAST_CALL, now.toString());
    },
  });

  React.useEffect(() => {
    const now = new Date().getTime();
    const timeSinceLastCall = now - lastCall;

    if (!events || timeSinceLastCall > EVENTS_SPOTS_CACHE_TTL) {
      getEvents({
        fetchPolicy: timeSinceLastCall > EVENTS_SPOTS_CACHE_TTL ? 'network-only' : 'cache-first',
      });
    }
  }, [events, lastCall]);

  if (!events) {
    return null;
  }

  return (
    <>
      <Highlight type="event" />
      <Sliders categories={events} />
    </>
  );
}
